'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.antDecorator = antDecorator;
function antDecorator(Vue) {
  return Vue.directive('decorator', {});
}

exports['default'] = {
  // just for tag
  install: function install(Vue) {
    antDecorator(Vue);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/lib/_util/FormDecoratorDirective.js
// module id = pnwi
// module chunks = 189